(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('managingTokensActions', managingTokensActionsFactory);

  /** @ngInject */
  function managingTokensActionsFactory(
    api,
    $q,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getManagingTokens: getManagingTokens,
      deleteManagingTokens: deleteManagingTokens,
      extendManagingTokens: extendManagingTokens,
      createDeviceSession: createDeviceSession,
      startDeviceService: startDeviceService
    };

    function getManagingTokens(email) {
      var deferred = $q.defer();
      api.getManagingTokens(email).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deleteManagingTokens(data) {
      var deferred = $q.defer();
      api.deleteManagingTokens(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function extendManagingTokens(data) {
      var deferred = $q.defer();
      api.extendManagingTokens(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function createDeviceSession(pointId) {
      var deferred = $q.defer();
      api.createDeviceSession(pointId).then(
        function (data) {
          deferred.resolve(data);
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('OPEN_SESSION')
            }
          });
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function startDeviceService(facilityId, pointId, token) {
      var deferred = $q.defer();
      api.startDeviceService(facilityId, pointId, token).then(
        function (data) {
          deferred.resolve(data);
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('TOKEN_INSERTED')
            }
          });
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

  }
})();
